import React from 'react'
import useSpawner from './use-spawner'
import { observer } from 'mobx-react'

function Pool () {
  const spawner = useSpawner()

  return spawner.getSpawns()
}

export default observer(Pool)
